import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette, spacing } = lightTheme;

const styles: Record<string, SxProps> = {
  title: { fontWeight: 700 },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing(1)
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '0.25rem',
    boxShadow: '0px 3.855px 15.419px 0px rgba(151, 151, 151, 0.16)',
    marginBottom: spacing(1),
    padding: spacing(1)
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  contentContainerWrapper: {
    width: '100%'
  },
  imageBox: {
    width: '100%',
    height: '100%',
    borderRadius: '0.25rem',
    border: `0.063rem solid ${palette.lightishAqua.main}`,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    marginRight: { md: spacing(0.5) },
    marginBottom: {
      xs: spacing(1),
      md: 0
    }
  },
  image: {
    height: 'auto',
    width: '100%',
    padding: '0.5rem'
  },
  buttonContainer: {
    width: '100%',
    marginTop: spacing(1)
  }
};

export default styles;
